type PageTitleProps = {
    title: string;
};

function PageTitle({ title }: PageTitleProps): JSX.Element {
    return <h1 className="text-2xl text-gray-900 font-bold dark:text-white/[0.87]">{title}</h1>;
}
export default PageTitle;
